import 'client/javascript/main';
import * as storage from 'client/javascript/storage';
import WeGlide from 'client/javascript/we_glide/we_glide';
import getClosestMarket from 'client/javascript/get_closest_market';
import { Select } from '@wework/ray-core';
import { onContentLoaded } from 'client/javascript/on_content_loaded';
import { onPolyfillsLoaded } from 'client/javascript/util/polyfills';
import { trackInteraction, setupScrollAnalyticsTracking } from 'client/javascript/analytics';
import { setupWizardOverlay } from './wizard/overlay';

const NUMBER_OF_RESULTS = 1;
const selectorBelowFold = '[data-section-id="home-below-fold"]';

onContentLoaded(() => {
  onPolyfillsLoaded(async () => {
    setupHeroSlider();
    await populateLocationDropdown();

    setupWizardOverlay();

    // ANALYTICS
    setupLinkAnalyticsTracking();
    setupScrollAnalyticsTracking({
      label: 'homepage scrolled below the fold',
      selector: selectorBelowFold
    });
  });
});

async function populateLocationDropdown() {
  const closestMarket = (await getClosestMarket(NUMBER_OF_RESULTS)) || {};
  const locationsDropdownSelect = Select.create(document.getElementById('locations-dropdown-select__container'));
  const locationIdFromLocalStorage = storage.getLocationId();

  const locationId = locationIdFromLocalStorage || closestMarket.id;
  locationsDropdownSelect.set(locationId);
}

function setupHeroSlider() {
  const glide = new WeGlide('.home-hero__glide');
  glide.mount();
}

/* ANALYTICS: clicking anchor tags below the fold */
function setupLinkAnalyticsTracking() {
  const anchorTagsInSectionBelowFold = document.querySelectorAll(`${selectorBelowFold} a`);
  Array.from(anchorTagsInSectionBelowFold).forEach(anchorTag =>
    anchorTag.addEventListener('click', handleClickAnchorTag)
  );
}

function handleClickAnchorTag(event) {
  const toPath = event.currentTarget.href;
  trackInteraction({ label: 'homepage below the fold content', toPath });
}
